import { getISOWeeksInYear } from 'date-fns';
import { getDayOfYear } from './get-day-of-year';
/**
 * Returns the ISO week number and ISO week year for a given date.
 * @hidden
 * @param year The year of the date.
 * @param month The month of the date.
 * @param day The day of the date.
 */
export const getIsoWeekValues = (year, month, day) => {
    const dayOfYear = getDayOfYear(year, month, day);
    const dayOfWeek = getIsoDayOfWeek(year, month, day);
    let weekOfYear = Math.floor((dayOfYear - dayOfWeek + 10) / 7);
    let weekYear;
    if (weekOfYear < 1) {
        weekYear = year - 1;
        weekOfYear = getISOWeeksInYear(Date.UTC(weekYear, 1));
    }
    else if (weekOfYear > getISOWeeksInYear(Date.UTC(year, 1))) {
        weekYear = year + 1;
        weekOfYear = 1;
    }
    else {
        weekYear = year;
    }
    return { weekYear, weekOfYear };
};
const getIsoDayOfWeek = (year, month, day) => {
    const dayOfWeek = new Date(Date.UTC(year, month - 1, day)).getUTCDay();
    return dayOfWeek === 0 ? 7 : dayOfWeek;
};
//# sourceMappingURL=get-iso-week-values.js.map